import ChallengeStickerInfo from './ChallengeStickerInfo';

export default ChallengeStickerInfo;
